import React from "react"
import { Grid } from "@mui/material/"
import NLPuploadContent from "./content/nlpUpload"

export default function NLPupload() {
  return (
    <Grid
      container
      xs={12}
      sm={12}
      md={12}
      lg={12}
      spacing={3}
      className="searchContainer"
    >
  
      <Grid item xs={12} className="marginCenter">
        <NLPuploadContent />
      </Grid>

    </Grid>
  )
}
